import type { WorkspaceBackupEnvelope } from "./workspace-backup";

export interface WorkspaceBackupDownloadAdapter {
  createBlob:(text:string)=>Blob;
  createObjectUrl:(blob:Blob)=>string;
  revokeObjectUrl:(url:string)=>void;
}

const browserDownloadAdapter:WorkspaceBackupDownloadAdapter={
  createBlob:text=>new Blob([text],{type:"application/json;charset=utf-8"}),
  createObjectUrl:blob=>URL.createObjectURL(blob),
  revokeObjectUrl:url=>URL.revokeObjectURL(url),
};

export interface PreparedWorkspaceBackupDownload { filename:string; json:string; objectUrl:string; revoke:()=>void; }

/** Prepares a file candidate. The user activates the visible native download link. */
export function prepareWorkspaceBackupDownload(filename:string,envelope:WorkspaceBackupEnvelope,adapter:WorkspaceBackupDownloadAdapter=browserDownloadAdapter):PreparedWorkspaceBackupDownload {
  const json=JSON.stringify(envelope,null,2),blob=adapter.createBlob(json),objectUrl=adapter.createObjectUrl(blob);
  return {filename,json,objectUrl,revoke:()=>adapter.revokeObjectUrl(objectUrl)};
}

/** Avoids only overlapping preparation attempts; a later deliberate preparation is allowed. */
export function createWorkspaceBackupDownloadGuard(){
  let inFlight=false;
  return {async run<T>(operation:()=>Promise<T>|T):Promise<{performed:boolean;value?:T}>{
    if(inFlight)return {performed:false};
    inFlight=true;
    try{return {performed:true,value:await operation()};}finally{inFlight=false;}
  }};
}
